var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"wechat_auth_tips"},[_c('p',[_vm._v("诺亚荣耀保险经纪联合保险师共同为您提供计划书服务")]),_c('i',{staticClass:"iconfont icon-close_line",on:{"click":_vm.onClose}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }